import { render } from "./SaveAppComponent.vue?vue&type=template&id=ca16c22a&scoped=true"
import script from "./SaveAppComponent.vue?vue&type=script&lang=js"
export * from "./SaveAppComponent.vue?vue&type=script&lang=js"

import "./SaveAppComponent.vue?vue&type=style&index=0&id=ca16c22a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca16c22a"]])

export default __exports__